import React, { createContext, useContext, useState, useEffect } from "react";
import { connect } from "react-redux";

import { useHistory } from 'react-router-dom';

import { useDrizzleContext } from "../drizzle/drizzleContext";

import crypto from 'crypto-js';

import * as LoginActions from "./actions";

const AuthUserContext = createContext(null);
const AuthOperationContext = createContext({
  login: (_) => console.error("The provider has not been set up."),
  logout: () => console.error("The provider has not been set up.")
})

const AuthUserProvider = ({
  dispatch,
  contracts,
  accounts,
  accountChangedLower,
  transactions,
  transactionStack,
  isValid,
  isLower,
  validating,
  grantingLower,
  children
}) => {
  const history = useHistory();

  const drizzle = useDrizzleContext();
  const contract = drizzle.contracts.THDJabraToken;
  const [ savedAccount, setSavedAccount ] = useState(accounts[0]);

  const [ dataKey, setDataKey ] = useState(null);
  const [ dataKeyBalance, setDataKeyBalance ] = useState(null);
  const [ stackId, setStackId ] = useState(null);

  const [ userId, setUserId ] = useState(null);
  const [ authUser, setAuthUser ] = useState(null);

  const encryptedJson = {
    "version": 3,
    "id": "5301c8ce-4213-436f-af5d-06b6a2ef505a",
    "address": "1392ef24b278f91db7f9c1f0edbe902736d0dd63",
    "crypto": {
      "ciphertext": "f03d77562cc066bbd328616d5c03144006a45faa92238a88d7b2b7c6db26f7b9",
      "cipherparams": {
        "iv": "814087276f901480e38cfc1a872d652f"
      },
      "cipher": "aes-128-ctr",
      "kdf": "scrypt",
      "kdfparams": {
        "dklen": 32,
        "salt": "fda66b98fcd52a98083d534b00c37614616e08f1c794dcf8605e8f4b6c5e7b30",
        "n": 8192,
        "r": 8,
        "p": 1
      },
      "mac": "8d74dcc1ff9facd1f07b7676850b0a8739c209d9c6872b56c979a3cdc4e4ccdf"
    }
  };
  const word = "F2DD0437342FA4AE2A0065C34AA2996E";
  const key = crypto.enc.Utf8.parse("d12db5e677e56d8cc075c3cda3e6a77ab3e506e1e07c6ce415a5407ef08ac0a5");
  const iv = crypto.enc.Utf8.parse("09cbf27d9cb1b3eb34910337256ae09cd46c36d28fd878bca973bbf9b3657d2d");

  /*const encryptedJson = {
    version: 3,
    id: 'f36c0bee-4540-4f65-81e1-e37a3abffb76',
    address: '220e9eeacbcd69f6a45f7a9fe007cc2049ff2666',
    crypto: {
      ciphertext: '2353087b9a383bfd997f210c37dcb7356666b798d7910431d083f406bae13a68',
      cipherparams: { iv: '0209457b26462251419d10d5f9fe8a51' },
      cipher: 'aes-128-ctr',
      kdf: 'scrypt',
      kdfparams: {
        dklen: 32,
        salt: '955d579ccf8a17084773f587c0d6f1cc5046bcfef077088a4ccf70a23de53d52',
        n: 8192,
        r: 8,
        p: 1
      },
      mac: '57c6e62d73a771caf3f5ebf8a6112480dab91ce2492192674eb09a1ed5f70989'
    }
  };
  const word = "F2DD0437342FA4AE2A0065C34AA2996E";
  const key = crypto.enc.Utf8.parse("d12db5e677e56d8cc075c3cda3e6a77ab3e506e1e07c6ce415a5407ef08ac0a5");
  const iv = crypto.enc.Utf8.parse("09cbf27d9cb1b3eb34910337256ae09cd46c36d28fd878bca973bbf9b3657d2d");*/

  const Decrypt = () => {
    const encryptedHexStr = crypto.enc.Hex.parse(word);
    const srcs = crypto.enc.Base64.stringify(encryptedHexStr);
    const decrypt = crypto.AES.decrypt(srcs, key, { iv: iv, mode: crypto.mode.CBC, padding: crypto.pad.Pkcs7 });
    const decryptedString = decrypt.toString(crypto.enc.Utf8);
    return decryptedString.toString();
  };

  useEffect(async () => {
    if (dataKey === null)
      return;

    var _isValid = contracts.THDJabraToken.checkIdentification[dataKey]
      ? contracts.THDJabraToken.checkIdentification[dataKey].value
      : null;

    if (_isValid === null)
      return;

    else if (_isValid) {
      dispatch(notifyLoginResult(true));
      var _dataKeyBalance = await contract.methods.checkBalance.cacheCall(accounts[0]);
      dispatch(sendsStateValidation(_isValid, true));
      setDataKeyBalance(_dataKeyBalance);
    } else {
      dispatch(notifyLoginResult(false));
      setDataKey(null);
      setAuthUser(null);
      _isValid = false;
      dispatch(sendsStateValidation(_isValid, false));
    }
  }, [contracts, dataKey]);

  useEffect(() => {
    if (dataKeyBalance === null)
      return;

    var _isLower = contracts.THDJabraToken.checkBalance[dataKeyBalance]
      ? contracts.THDJabraToken.checkBalance[dataKeyBalance].value
      : null;

    if (_isLower === null)
      return;

    dispatch(judgeLowerOrNot(_isLower));
  }, [contracts, dataKeyBalance]);

  useEffect(async () => {
    if (isValid && isLower && !validating) {
      var pk = drizzle.web3.eth.accounts.decrypt(encryptedJson, Decrypt());
      await drizzle.web3.eth.accounts.wallet.add(pk.privateKey);
      pk = null;
      setDataKey(null);
      dispatch(notifyChangedAddressLower(drizzle.web3))
    } else if (isValid && !isLower && !validating) {
      setDataKey(null);
      setAuthUser({ userId });
      history.push("/reserve");
      dispatch(sendsStateValidation(false, false));
    }
  }, [isValid, isLower, validating]);

  useEffect(async () => {
    if (!accountChangedLower)
      return;
    else if (accountChangedLower === 1)
      grantForLowerEth();
    else if (accountChangedLower === 2) {
      setDataKey(null);
      setAuthUser({ userId });
      history.push("/reserve");
      dispatch(sendsStateValidation(false, false));
    }
  }, [accounts]);

  const grantForLowerEth = async () => {
    const estimatedGas = await contract.methods.grantForLowerEth(
        savedAccount,
      ).estimateGas({
        from: accounts[0]
    });
    const estimatedGasPrice = await drizzle.web3.eth.getGasPrice();
    const multiplicationFactor = 1.1;
    const gasPriceMultiplication = 1.1;

    const _stackId = await contract.methods["grantForLowerEth"].cacheSend(
      savedAccount, {
      from: accounts[0],
      gas: Math.floor(estimatedGas*multiplicationFactor),
      gasPrice: Math.floor(estimatedGasPrice*gasPriceMultiplication),
    });
    dispatch(notifyGrantsLower(_stackId));
    setStackId(_stackId);
  };

  useEffect(() => {
    if (!grantingLower)
      return;

    const txHash = transactionStack[stackId];

    if (transactions[txHash] && transactions[txHash].status === 'success') {
      dispatch(notifyGrantedLower());
      dispatch(notifyRecoverAddressLower(drizzle.web3));
      return;
    }
  }, [transactions]);

  const login = (emailAddress, password) => {
    doAuthenticate(emailAddress, password);
  }
  
  const logout = async () => {
    setAuthUser(null)
  }

  const doAuthenticate = (emailAddress, password) => {
    var splitEmailAddress = null;

    if (emailAddress !== "")
      splitEmailAddress = emailAddress.split('@');
    else
      splitEmailAddress = "blank@blank";

    const userId = splitEmailAddress[0];
    const domainname = "ml.tanaka.co.jp";

    const userIdDigest = drizzle.web3.utils.sha3(userId);
    setUserId(userIdDigest);
    const passwordDigest = drizzle.web3.utils.sha3(password);
    const domainnameDigest = drizzle.web3.utils.sha3(domainname);
    
    return checkIdentification(userIdDigest, passwordDigest, domainnameDigest);
  }

  const checkIdentification = async (userIdDigest, passwordDigest, domainnameDigest) => {
    var _dataKey = await contract.methods.checkIdentification.cacheCall(userIdDigest, passwordDigest, domainnameDigest);
    setDataKey(_dataKey);
  }

  return (
    <AuthOperationContext.Provider value={{login, logout}}>
      <AuthUserContext.Provider value={authUser}>
        { children }
      </AuthUserContext.Provider>
    </AuthOperationContext.Provider>
  )
}

const notifyChangedAddressLower = web3 => {
  return {
    type: LoginActions.ACCOUNTS_CHANGED_LOWER,
    web3: web3
  };
}

const notifyRecoverAddressLower = web3 => {
  return {
    type: LoginActions.ACCOUNTS_RECOVERED_LOWER,
    web3: web3
  };
}

const sendsStateValidation = (isValid, validating) => {
  return {
    isValid: isValid,
    validating: validating,
    type: LoginActions.LOGIN_VALIDATE
  }
}

const judgeLowerOrNot = isLower => {
  return {
    isLower: isLower,
    type: LoginActions.LOGIN_JUDGE
  }
}

const notifyLoginResult = loginResult => {
  return {
    type: LoginActions.LOGIN_TRIED,
    loginResult: loginResult
  }
}

const notifyGrantsLower = stackId => {
  return {
    type: LoginActions.LOGIN_GRANTS
  }
}

const notifyGrantedLower = () => {
  return {
    type: LoginActions.LOGIN_GRANTED
  }
}

export const useAuthUser = () => useContext(AuthUserContext)
export const useLogin = () => useContext(AuthOperationContext).login
export const useLogout = () => useContext(AuthOperationContext).logout

const mapStateToProps = state => {
  return {
    contracts: state.contracts,
    accounts: state.accounts,
    transactions: state.transactions,
    transactionStack: state.transactionStack,
    accounts: state.accounts,
    accountChangedLower: state.login.accountChangedLower,
    isValid: state.login.isValid,
    isLower: state.login.isLower,
    validating: state.login.validating,
    grantingLower: state.login.grantingLower
  };
};

export default connect(mapStateToProps)(AuthUserProvider);
